import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Button,
	useDisclosure,
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import addToArchiveApi from '../../api/addToArchiveApi';

const ArcPkgUnarc = ({ state, changeState, item, reload }) => {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const cancelRef = useRef();
	const [loading, setLoading] = useState();

	useEffect(() => {
		if (state) {
			onOpen();
		}
	}, [state]);

	const handleUnarchive = async () => {
		setLoading(true);
		try {
			const response = await addToArchiveApi(item.packageId, false);
			console.log(response);
			setLoading(false);
			onClose();
			changeState(false);
			reload((prev) => !prev);
		} catch (error) {
			console.log('error is ', error);
			setLoading(false);
			onClose();
			changeState(false);
			reload((prev) => !prev);
		}
	};

	return (
		<AlertDialog
			isOpen={isOpen}
			leastDestructiveRef={cancelRef}
			onClose={onClose}
		>
			<AlertDialogOverlay>
				<AlertDialogContent>
					<AlertDialogHeader fontSize='lg' fontWeight='bold'>
						Unarchive Package
					</AlertDialogHeader>

					<AlertDialogBody>Are you sure?</AlertDialogBody>

					<AlertDialogFooter>
						<Button
							ref={cancelRef}
							onClick={() => {
								changeState(false);
								onClose();
							}}
						>
							Cancel
						</Button>
						<Button
							colorScheme='green'
							onClick={handleUnarchive}
							ml={3}
							isLoading={loading}
						>
							Confirm
						</Button>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialogOverlay>
		</AlertDialog>
	);
};

export default ArcPkgUnarc;
